(function () {
  function init() {
    const btn = document.querySelector("[data-kyp-game-button]");
    if (!btn) return;

    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      const isLoggedIn = btn.dataset.isLoggedIn === "true";
      const hasActiveMembership = btn.dataset.hasActiveMembership === "true";
      const loginUrl = btn.dataset.loginUrl || "/account/login";
      const plansUrl = btn.dataset.plansUrl || "/pages/membership-plans";
      const customerId = btn.dataset.customerId;

      if (!isLoggedIn) {
        window.location.href = loginUrl;
        return;
      }

      if (!hasActiveMembership) {
        window.location.href = plansUrl;
        return;
      }

      try {
        btn.classList.add("is-loading");

        const res = await fetch("/apps/sigil", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customerid: Number(customerId), hasgame: true , haspda: false}),
        });

        if (!res.ok) {
          throw new Error("SSO request failed: " + res.status);
        }

        const data = await res.json();
        if (!data.sso_link) throw new Error("Missing sso_link");

        window.location.href = data.sso_link;
      } catch (err) {
        console.error(err);
        // Fallback: send them to plans or show a message
        window.location.href = plansUrl;
      } finally {
        btn.classList.remove("is-loading");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
